/* eslint-disable no-param-reassign */
import moment from 'moment';
import store from '@carvana/purchase-store';
import * as services from '../../services';
import * as types from '../action-types';

const getStepByStepName = (stepName, steps) => {
  return steps[stepName] || {};
};

const completeTransferStep = steps => {
  const transferSchedule = getStepByStepName('transferSchedule', steps);
  if (Object.keys(transferSchedule).length > 0) {
    transferSchedule.isEnabled = false;
    transferSchedule.status = 'Complete';
  }
};

const pauseLockTimer = () =>
  store.dispatch({
    type: types.PAUSE_LOCK_TIMER,
    async payload() {
      return services.pauseLockTimer();
    }
  });

const needsLockTimerPaused = vehicleLock =>
  !!(
    vehicleLock?.isAvailable &&
    moment(vehicleLock?.expiresOn).isBetween(
      moment(),
      moment().add(10, 'years')
    )
  );

const OrderPlacedActions = async (res, availableOptions) => {
  const steps = res?.status?.steps;
  const { vehicleLock } = res || {};
  const { needsToScheduleTimeSlot } = availableOptions;

  if (!needsToScheduleTimeSlot) {
    completeTransferStep(steps);

    if (needsLockTimerPaused(vehicleLock)) {
      pauseLockTimer();
    }
  }

  return Promise.resolve(res);
};

export default OrderPlacedActions;
